import { filterInstagramCookies, fixJsonFormat } from '../cookies'
import { ParseError } from '../errors'
import { type AccountData, emptyAccount } from '../models'

export function splitFullFormatRecords(data: string): string[] {
  return data
    .trim()
    .split('\n\n')
    .map((b) => b.trim())
    .filter((b) => b.length > 0)
}

export function canParseFullFormat(data: string): boolean {
  const lower = data.toLowerCase()
  return lower.includes('2fa:') && lower.includes('cookies:')
}

export function parseFullFormat(record: string): AccountData {
  let login = ''
  let password = ''
  let twofaKey = ''
  let cookiesJson = ''

  for (const raw of record.trim().split('\n')) {
    const line = raw.trim()
    if (line.startsWith('login:')) login = line.slice('login:'.length).trim()
    else if (line.startsWith('password:')) password = line.slice('password:'.length).trim()
    else if (line.startsWith('2fa:')) twofaKey = line.slice('2fa:'.length).trim().replaceAll(' ', '')
    else if (line.startsWith('cookies:')) cookiesJson = line.slice('cookies:'.length).trim()
  }

  if (!login || !password) throw new ParseError('Missing login or password')
  if (!cookiesJson) throw new ParseError('Missing cookies')

  const fixed = fixJsonFormat(cookiesJson)
  let parsed: { cookies?: Array<Record<string, unknown>> }
  try {
    parsed = JSON.parse(fixed)
  } catch (e) {
    throw new ParseError(`Invalid JSON in cookies: ${(e as Error).message}`)
  }

  const cookieObjects = (parsed.cookies ?? []) as Array<Record<string, string>>
  const cookies = filterInstagramCookies(cookieObjects)

  if (!('sessionid' in cookies) || !('ds_user_id' in cookies)) {
    throw new ParseError('Missing required cookies: sessionid, ds_user_id')
  }

  return {
    ...emptyAccount(),
    login,
    password,
    twofaKey,
    cookies,
  }
}
